import { LINKEDIN_PERSON_URN_PREFIX } from './data';
import { convertLinkedInIdToUrn } from './common';

export enum RoleType {
    administrator = 'ADMINISTRATOR',
    directSponsoredContentPoster = 'DIRECT_SPONSORED_CONTENT_POSTER',
    recruitingPoster = 'RECRUITING_POSTER',
    leadCaptureAdministrator = 'LEAD_CAPTURE_ADMINISTRATOR',
    leadGenFormsManager = 'LEAD_GEN_FORMS_MANAGER',
}

export function getLocalizedFullName(account: LinkedInBasicProfile): string {
    return `${account.localizedFirstName} ${account.localizedLastName}`;
}

export function getPersonUrn(id: string): string {
    return convertLinkedInIdToUrn(id, LINKEDIN_PERSON_URN_PREFIX);
}

/**
 * @see https://docs.microsoft.com/en-us/linkedin/shared/references/v2/profile/lite-profile?context=linkedin/consumer/context
 */
export interface LinkedInBasicProfile {
    id: string;
    firstName: MultiLocaleStringSchema;
    localizedFirstName: string;
    lastName: MultiLocaleStringSchema;
    localizedLastName: string;
    profilePicture: ProfilePictureField;
    vanityName: string;
}

/**
 * @see https://docs.microsoft.com/en-us/linkedin/shared/references/v2/object-types#multilocalestring
 * @see https://docs.microsoft.com/en-us/linkedin/compliance/faqs
 */
export interface MultiLocaleStringSchema {
    localized: LinkedInNameLocale[];
    preferredLocale?: LinkedInPreferredLocale;
}

export interface LinkedInNameLocale {
    locale: string;
    string: string;
}

export interface LinkedInPreferredLocale {
    country?: string;
    language: string;
}

/**
 * @see https://docs.microsoft.com/en-us/linkedin/shared/references/v2/profile/profile-picture
 */
export interface ProfilePictureField {
    displayImage: string;
}
